module.exports = __webpack_public_path__ + "static/media/green-check.b6b42d9d.svg";